export default function scaleCanvasForDpi(canvas, context) {
  const pixelRatio = devicePixelRatio || 1

  const { width: virtualWidth, height: virtualHeight } = canvas.getBoundingClientRect()
  canvas.width = virtualWidth * pixelRatio
  canvas.height = virtualHeight * pixelRatio

  // Scale canvas instead of adjusting all drawing calls to DPI
  context.scale(pixelRatio, pixelRatio)

  return { pixelRatio, virtualWidth, virtualHeight }
}
